import React from 'react'
import PropTypes from 'prop-types'

import UnsortedList from './UnsortedList'
import SortedList from "./SortedList"

const CustomRefinementList = (props) => {
  const {
    items,
    name,
    handleFacetClick,
    handleFilterClick,
    selectedFacets,
    selectedValues,
    isMobile,
    expanded,
    facetId,
    values,
    sortable,
  } = props

  if (sortable) {
    return (
      <SortedList
        key={`desktop-facet-${name}`}
        selectedFacets={selectedFacets}
        handleFacetClick={handleFacetClick}
        name={name}
        items={items}
        facetId={facetId}
        isMobile={isMobile}
        expanded={expanded}
      />
    )
  }

  return (
    <UnsortedList
      handleFilterClick={handleFilterClick}
      selectedValues={selectedValues}
      name={name}
      values={values}
      isMobile={isMobile}
      expanded={expanded}
    />
  )
}

export default CustomRefinementList

CustomRefinementList.defaultProps = {
  items: [],
  name: '',
  selectedFacets: {},
  isMobile: false,
  expanded: true,
  facetId: '',
}

CustomRefinementList.propTypes = {
  items: PropTypes.array,
  name: PropTypes.string,
  handleFacetClick: PropTypes.func.isRequired,
  selectedFacets: PropTypes.object,
  isMobile: PropTypes.bool,
  expanded: PropTypes.bool,
  facetId: PropTypes.string,
}
